// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3pU0U","additionalInfo":"AgreementModal_additionalInfo__2B-1J"};